import { useState, useEffect } from "react";
import { Outlet, useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { getDeviceOrientation } from "../../utils/generalUtils";
import MainContainer from "../console/layout/MainContainer";
import ProfileBackground from "../../assets/images/backgrounds/UC_BG_Console.png";
import SelectorIntraverseLogoIcon from "../../assets/images/logos/HeroLogoIntraverse.png";
import { setColor, setFont } from "../../assets/styles/styles";
import Button from "../../components/common/button/Button";
import Footer from "../../components/layout/footer/Footer";
import { sendVerificationEmail, RegisterUser } from "../../api/UserController";
import { countryOptions } from "../../constants";
import { CheckBoxMain } from "../../components/common/checkBox/CheckBoxMain";
import PasswordChecker from "../login/PasswordChecker";
import BirthdayIcon from "../../assets/images/icons/UC_Sprite_Icon_Birthday.png";
import { SaveUser } from "../../redux/actions/UserActions";

const CreateUser = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const oldUserOrExisiting = useSelector((state) => state.user);
    const user = useSelector((state) => state.user);
    const [birthday, setBirthday] = useState("");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isNewsChecked, setIsNewsChecked] = useState(false);
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [isBirthdayInputValid, setIsBirthdayInputValid] = useState(false);

    const handleNewsCheckboxChange = () => {
        setIsNewsChecked(!isNewsChecked);
    };

    const handleTermsCheckboxChange = () => {
        setIsTermsChecked(true);
    };

    const handleCreateAccount = async () => {
        const [dd, mm, yyyy] = birthday.split("-");
        const formattedBirthdate = `${yyyy}-${mm}-${dd}`;
        const resp = await RegisterUser("", "", email, password, username, formattedBirthdate, isNewsChecked);
        if (resp.userId && resp.token) {
            dispatch(
                SaveUser(
                    resp.user.email,
                    resp.user.displayName,
                    resp.token,
                    resp.refreshToken,
                    resp.userId,
                    resp.userRoles[0],
                    false,
                    resp.expiration,
                    "",
                    resp.user.userBirthday,
                    resp.isUserOwnerOfClient
                )
            );
            await sendVerificationEmail(resp.userId, resp.token);
        }
    };

    useEffect(() => {
        if (user && user.token && user.userId) {
            navigate("/verify-email");
        }
    }, [user, navigate]);

    const handleBirthdayInput = (e) => {
        let value = e.target.value.replace(/[^\d-]/g, "");

        // Auto-insert dashes for DD-MM-YYYY
        if (value.length === 2 && birthday.length === 1) value += "-";
        if (value.length === 5 && birthday.length === 4) value += "-";
        if (value.length === 3 && value[2] !== "-") value = `${value.slice(0, 2)}-${value.slice(2)}`;
        if (value.length === 6 && value[5] !== "-") value = `${value.slice(0, 5)}-${value.slice(5)}`;
        value = value.slice(0, 10);

        setBirthday(value);

        let valid = false;
        if (value.length === 10) {
            const [dd, mm, yyyy] = value.split("-").map(Number);
            const now = new Date();

            if (mm < 1 || mm > 12) {
                valid = false;
                return;
            }
            const dateObj = new Date(yyyy, mm - 1, dd);

            valid =
                dateObj.getFullYear() === yyyy &&
                dateObj.getMonth() === mm - 1 &&
                dateObj.getDate() === dd &&
                dateObj <= now &&
                yyyy >= 1900;

            const thirteenYearsAgo = new Date(now.getFullYear() - 13, now.getMonth(), now.getDate());
            if (dateObj > thirteenYearsAgo) valid = false;
        }

        setIsBirthdayInputValid(valid);
    };

    return (
        <ConsoleContainer background={ProfileBackground}>
            <MainContainer>
                <Outlet />
                <ContentContainer>
                    <StyledImage src={SelectorIntraverseLogoIcon} alt="Intraverse Logo" />
                    <Title>Create your Intraverse account in 2 easy steps.</Title>

                    <Label>Birthdate</Label>
                    <InputBox
                        type="text"
                        placeholder="What's your birthday?"
                        value={birthday}
                        onChange={handleBirthdayInput}
                    />

                    <Label>Username</Label>
                    <InputBox
                        type="text"
                        id="username"
                        placeholder="What's your username?"
                        value={username}
                        onChange={(e) => setUsername(e.currentTarget.value)}
                    />

                    <Label>Email</Label>
                    <InputBox
                        type="email"
                        id="email"
                        placeholder="What's your email?"
                        value={email}
                        onChange={(e) => setEmail(e.currentTarget.value)}
                    />

                    <Label>New Password</Label>
                    <InputBox
                        type="password"
                        id="password"
                        placeholder="What's your password?"
                        value={password}
                        onChange={(e) => setPassword(e.currentTarget.value)}
                    />

                    <PasswordChecker password={password} />
                    <CheckboxContainer>
                        <TermsText>
                            <CheckBoxMain
                                width="20px"
                                height="20px"
                                checked={isNewsChecked}
                                onChange={handleNewsCheckboxChange}
                                margin={"0rem 0.6rem 0rem 0rem"}
                            />
                            Receive news, special offers, event information, and feedback surveys by email from
                            Intraverse.
                        </TermsText>
                        <TermsText>
                            <CheckBoxMain
                                width="20px"
                                height="20px"
                                checked={isTermsChecked}
                                onChange={handleTermsCheckboxChange}
                                margin={"0rem 0.6rem 0rem 0rem"}
                            />
                            I agree to Intraverse's <YellowText>Privacy Policy and Terms and Conditions.</YellowText>
                        </TermsText>
                    </CheckboxContainer>
                    <Button
                        margin={"20px 0px 10px 0px"}
                        label="Continue to Step 2"
                        variant="PurpleButton"
                        buttonWidth="100%"
                        disabled={!isTermsChecked}
                        onClick={handleCreateAccount}
                    />
                </ContentContainer>
            </MainContainer>
        </ConsoleContainer>
    );
};

export default CreateUser;

const ConsoleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    background: url(${(props) => props.background});
    background-size: cover;
    background-color: #1b1b23;
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 40%;
    margin: 0rem auto;
    border-radius: 10px;

    @media (max-width: 1024px) {
        width: 75%;
    }

    @media (max-width: 768px) {
        width: 85%;
    }

    @media (max-width: 480px) {
        width: 95%;
        padding: 1.5rem;
    }
`;

const StyledImage = styled.img`
    width: 60%;
    max-width: 400px;
    height: auto;

    @media (max-width: 768px) {
        width: 80%;
    }
`;

const Title = styled.div`
    width: 100%;
    color: ${setColor.circularProgress};
    text-align: center;
    font-family: ${setFont.barlow};
    font-size: 16px;
    text-transform: none;
    letter-spacing: normal;
`;

const InputBox = styled.input`
    width: 100%;
    height: 45px;
    padding: 10px;
    border: none;
    border-radius: 5px;
    background-color: #00000066;
    color: #ffffff;
    font-size: 16px;
`;
const Label = styled.label`
    width: 100%;
    font-weight: 700;
    font-size: 16px;
    color: ${setColor.circularProgress};
    margin: 1rem 0 0.5rem 0;
`;

const TermsText = styled.p`
    color: #fbfcff;
    text-align: left;
    font-family: ${setFont.barlow};
    font-size: 15px;
    font-weight: 500;
    margin: 0.7rem 0;
    display: flex;
    flex-direction: row;
    font-style: normal;
`;
const YellowText = styled.span`
    color: ${setColor.spanTextColor};
    font-weight: 700;
`;

const CheckboxContainer = styled.div`
    display: flex;
    align-items: flex-start;
    text-align: left;
    margin-top: 0.5rem;
    flex-direction: column;
    justify-content: center;
`;
